import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const MODULO = 'MODULO';
const LOADER = 'LOADER';
const LISTADO_STATUS = 'LISTADO_STATUS';
const LISTADO_PAISES = 'LISTADO_PAISES';

const setLoader = loader => ({
    type: LOADER,
    loader,
});


export const listarStatus = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/registro_marca/status', params).then((response)=>{
        const statu = [];
        response.forEach(item => {
            statu.push({
                value: item.id,
                label: item.status
            })
        })
        dispatch({ type: LISTADO_STATUS, listStatus: statu });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al listar estatus',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const reporteMarcas = () => (dispatch, getStore) => {
    let data = getStore().form.FormInformesRegistroMarca.values;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let reporte = 'listado_marcas';
    let estatus = '';
    let paisM = '';
    if (data === undefined){
        estatus = '';
    }else{
        if (data.status === '0'){
            estatus = ''
        }else{
            estatus = data.status;
        }
    }
    if (data === undefined){
        paisM = '';
    }else{
        if (data.pais === '0'){
            paisM = ''
        }else{
            paisM = data.pais;
        }
    }
    let producto = data.producto ? data.producto.value : '';
    const params = { id, reporte, estatus, producto, paisM };
    dispatch(setLoader(true));
    api.getPdf('/registro_marca/registro_marca', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'reporte_listado_marcas.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {
        if (error.status === 404) {
            NotificationManager.info(
                error.body.msj,
                'Informacion',
                5000
            );
        }
        if (error.status === 500) {
            NotificationManager.error(
                'Ocurrió un error al generar reporte',
                'Error',
                0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = { id, modulo }
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response) => {
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const excelMarcas = () => (dispatch, getStore) => {
    let data = getStore().form.FormInformesRegistroMarca.values;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let reporte = 'excel_marcas';
    let estatus = '';
    let paisM = '';
    if (data === undefined){
        estatus = '';
    }else{
        if (data.status === '0'){
            estatus = ''
        }else{
            estatus = data.status;
        }
    }
    if (data === undefined){
        paisM = '';
    }else{
        if (data.pais === '0'){
            paisM = ''
        }else{
            paisM = data.pais;
        }
    }
    let producto = data.producto ? data.producto.value : '';
    const params = { id, reporte, estatus, producto, paisM };
    dispatch(setLoader(true));
    api.getExcel('/registro_marca/registro_marca', params).then((response) => {

        const blob = response;
        const fileName = 'Listado_marcas.xlsx';

        // Descargar el archivo utilizando la función saveAs de file-saver
        const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(file, fileName);

    }).catch(error => {
        if (error === 404) {
            NotificationManager.error(
                "No se encontraron datos",
                'Informacion',
                5000
            );
        }
        if (error === 500) {
            NotificationManager.error(
                'Ocurrió un error al generar reporte',
                'Error',
                0
            );
        }
    })
    .finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarMarcas = (search) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, search };
    return api.get('/registro_marca/producto/productos', params).then((response)=>{
        const marca = [];
        response.forEach(item => {
            marca.push({
                value: item.id,
                label: item.descripcion
            })
        })
        return marca;
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al listar marcas',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarPaises = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/registro_marca/registro_marca/paises_marcas', params).then((response)=>{
        const paises = [];
        response.forEach(item => {
            paises.push({
                value: item.id,
                label: item.pais
            })
        })
        dispatch({ type: LISTADO_PAISES, listPais: paises });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const actions = {
    reporteMarcas,
    getModulo,
    listarStatus,
    listarMarcas,
    excelMarcas,
    listarPaises
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [LISTADO_STATUS]: (state, { listStatus}) => {
        return {
            ...state,
            listStatus
        }
    },
    [LISTADO_PAISES]: (state, { listPais}) => {
        return {
            ...state,
            listPais
        }
    }
};

export const initialState = {
    loader: false,
    modulo: [],
    listStatus: [],
    listPais: []
};

export default handleActions(reducers, initialState)
